/**
 * Link - Simple link component for navigation
 * Handles both internal and external links automatically
 */

import React from 'react'
import { Link as MuiLink } from '@mui/material'
import NextLink from 'next/link'

interface LinkProps {
	children: React.ReactNode
	href: string
	color?: 'primary' | 'secondary' | 'white' | 'inherit'
	openInNewTab?: boolean
	underline?: 'none' | 'hover' | 'always'
}

const Link: React.FC<LinkProps> = ({ children, href, color = 'primary', openInNewTab = false, underline = 'hover' }) => {
	const isExternal = href.startsWith('http') || href.startsWith('mailto')

	if (isExternal) {
		return (
			<MuiLink
				href={href}
				color={color}
				underline={underline}
				target={openInNewTab ? '_blank' : undefined}
				rel={openInNewTab ? 'noopener noreferrer' : undefined}
			>
				{children}
			</MuiLink>
		)
	}

	return (
		<NextLink href={href} passHref>
			<MuiLink color={color} underline={underline} target={openInNewTab ? '_blank' : undefined}>
				{children}
			</MuiLink>
		</NextLink>
	)
}

export default Link
